import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../CSS/App.css';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";

// Import Merch Assets
import A_Sweatshirt from '../merch/A_Sweatshirt.png';
import B_LongSleeve from '../merch/B_LongSleeve.png';
import C_GoldShirt from '../merch/C_GoldShirt.png';
import D_BlueShirt from '../merch/D_BlueShirt.png';
import E_GreenShirt from '../merch/E_GreenShirt.png';
import F_PinkShirt from '../merch/F_PinkShirt.png';
import G_HoodedSweatshirt from '../merch/G_HoodedSweatshirt.png';
import H_HoodedSweater from '../merch/H_HoodedSweater.png';
import I_Hat from '../merch/I_Hat.png';
import J_Beanie from '../merch/J_Beanie.png';
import K_Flag from '../merch/K_Flag.png';
import L_GoldFlag from '../merch/L_GoldFlag.png';
import M_BlueFlag from '../merch/M_BlueFlag.png';
import N_GreenFlag from '../merch/N_GreenFlag.png';
import O_PinkFlag from '../merch/O_PinkFlag.png';

const PRODUCTS = [
  { id: 'sweatshirt', name: 'Signature Sweatshirt', category: 'clothing', image: A_Sweatshirt, price: '$45.00', desc: 'Heavyweight blend sweatshirt.' },
  { id: 'longsleeve', name: 'Premium Long Sleeve', category: 'clothing', image: B_LongSleeve, price: '$35.00', desc: 'Soft-spun cotton sleeve shirt.' },
  { id: 'goldshirt', name: 'Gold Squad Tee', category: 'clothing', image: C_GoldShirt, price: '$25.00', desc: 'Official Gold Squad player shirt.' },
  { id: 'blueshirt', name: 'Blue Squad Tee', category: 'clothing', image: D_BlueShirt, price: '$25.00', desc: 'Official Blue Squad player shirt.' },
  { id: 'greenshirt', name: 'Green Squad Tee', category: 'clothing', image: E_GreenShirt, price: '$25.00', desc: 'Official Green Squad player shirt.' },
  { id: 'pinkshirt', name: 'Pink Squad Tee', category: 'clothing', image: F_PinkShirt, price: '$25.00', desc: 'Official Pink Squad player shirt.' },
  { id: 'hooded_sweatshirt', name: 'Extravalanza Hoodie', category: 'clothing', image: G_HoodedSweatshirt, price: '$50.00', desc: 'Cozy fleece-lined tournament hoodie.' },
  { id: 'hooded_sweater', name: 'Hooded Knit Sweater', category: 'clothing', image: H_HoodedSweater, price: '$55.00', desc: 'Premium knit performance sweater.' },
  { id: 'hat', name: 'Dad Hat', category: 'gear', image: I_Hat, price: '$20.00', desc: 'Adjustable strap curved-bill cap.' },
  { id: 'beanie', name: 'Knit Beanie', category: 'gear', image: J_Beanie, price: '$18.00', desc: 'Stretch-fit skullcap.' },
  { id: 'flag', name: 'League Banner Flag', category: 'flags', image: K_Flag, price: '$30.00', desc: '3x5ft official black & teal flag.' },
  { id: 'goldflag', name: 'Gold Squad Flag', category: 'flags', image: L_GoldFlag, price: '$30.00', desc: '3x5ft Gold Squad battle banner.' },
  { id: 'blueflag', name: 'Blue Squad Flag', category: 'flags', image: M_BlueFlag, price: '$30.00', desc: '3x5ft Blue Squad battle banner.' },
  { id: 'greenflag', name: 'Green Squad Flag', category: 'flags', image: N_GreenFlag, price: '$30.00', desc: '3x5ft Green Squad battle banner.' },
  { id: 'pinkflag', name: 'Pink Squad Flag', category: 'flags', image: O_PinkFlag, price: '$30.00', desc: '3x5ft Pink Squad battle banner.' },
  { id: 'flag_sticker', name: 'League Banner Sticker', category: 'stickers', image: K_Flag, price: '$5.00', desc: '3-inch official black & teal vinyl sticker.' },
  { id: 'goldflag_sticker', name: 'Gold Squad Sticker', category: 'stickers', image: L_GoldFlag, price: '$5.00', desc: '3-inch Gold Squad vinyl sticker.' },
  { id: 'blueflag_sticker', name: 'Blue Squad Sticker', category: 'stickers', image: M_BlueFlag, price: '$5.00', desc: '3-inch Blue Squad vinyl sticker.' },
  { id: 'greenflag_sticker', name: 'Green Squad Sticker', category: 'stickers', image: N_GreenFlag, price: '$5.00', desc: '3-inch Green Squad vinyl sticker.' },
  { id: 'pinkflag_sticker', name: 'Pink Squad Sticker', category: 'stickers', image: O_PinkFlag, price: '$5.00', desc: '3-inch Pink Squad vinyl sticker.' }
];

export default function Clothing() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    const tab = searchParams.get('tab') || 'all';
    setActiveTab(tab);
  }, [searchParams]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === 'all') {
      setSearchParams({});
    } else {
      setSearchParams({ tab });
    }
  };

  const filteredProducts = PRODUCTS.filter(p => {
    if (activeTab === 'all') return true;
    return p.category === activeTab;
  });

  return (
    <div className='background-component'>
      <NavScroll />

      <div className="clothing-container">
        {/* Header Block */}
        <div className="clothing-header">
          <p className="clothing-subtitle">
            Rep your squad with official Halo Extravalanza gear, clothing, and custom flags.
          </p>
        </div>

        {/* Categories Tab Swapper */}
        <div className="clothing-tabs">
          <button
            className={`clothing-tab-btn ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => handleTabChange('all')}
          >
            All Products
          </button>
          <button
            className={`clothing-tab-btn ${activeTab === 'clothing' ? 'active' : ''}`}
            onClick={() => handleTabChange('clothing')}
          >
            Clothing
          </button>
          <button
            className={`clothing-tab-btn ${activeTab === 'gear' ? 'active' : ''}`}
            onClick={() => handleTabChange('gear')}
          >
            Hats & Gear
          </button>
          <button
            className={`clothing-tab-btn ${activeTab === 'flags' ? 'active' : ''}`}
            onClick={() => handleTabChange('flags')}
          >
            Flags
          </button>
          <button
            className={`clothing-tab-btn ${activeTab === 'stickers' ? 'active' : ''}`}
            onClick={() => handleTabChange('stickers')}
          >
            Stickers
          </button>
        </div>

        {/* Scrollable Products Area */}
        <div className="clothing-content-scrollable">
          <div className="clothing-grid">
            {filteredProducts.map(product => (
              <div key={product.id} className="product-card">
                <div className="product-img-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-img"
                  />
                </div>
                <div className="product-info">
                  <div className="product-meta">
                    <span className="product-category">{product.category}</span>
                    <span className="product-price">{product.price}</span>
                  </div>
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-desc">{product.desc}</p>
                  <button className="product-buy-btn">
                    Available at LAN
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <SocialLinks />

      <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
      <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
    </div>
  );
}
